import { createMuiTheme } from '@material-ui/core/styles';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import emailjs from 'emailjs-com';

import {
    NAME_FIELD, ID_FIELD, MAIL_FIELD, NUMBER_FIELD, STRING_FIELD, PLATE_FIELD
} from './constants'

import {BRANCH_NAME, BRANCH_URL} from './config'


// App theme for MUI components
export const appTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#B68500",
    }
  },
});


// Validates input values according to the expected type
export const validateField = (fieldType, value) => {
    if (fieldType === NAME_FIELD){
        const regex = /^[A-Za-zñÑÁ-Źá-ź]{1,15}\s[A-Za-zñÑÁ-Źá-ź]{1,15}(\s[A-Za-zñÑÁ-Źá-ź]{1,15}$|$)/
        return regex.test(value.trim())
    }
    if (fieldType === NUMBER_FIELD){
        const regex = /^[0-9]+$/
        return regex.test(value)
    }
    if (fieldType === ID_FIELD){
        const regex = /^[a-z0-9]{9}$/
        return regex.test(value)
    }
    if (fieldType === MAIL_FIELD){
        const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
        return regex.test(value)
    }
    if (fieldType === STRING_FIELD){
        return value.length > 0
    }
    if (fieldType === PLATE_FIELD){
        const regexNumber = /^[0-9]{6}$/
        if (regexNumber.test(value)){
            return true
        }

        const regexAlphaNum = /^[a-z]{3}-[0-9]{3}$/
        return regexAlphaNum.test(value.toLowerCase())
    }
    return false
}


/*
 * Parse timestamp as object with date and time attributes that are human
 * readable. Timestamp should be in milliseconds
 */
export const parseTimestamp = timestamp => {
    if (timestamp === null)
    {
        return {date: "-", time: "-"}
    }
    const date = new Date(timestamp)
    var hours = date.getHours()
    var amPmSuffix = 'pm'
    if (hours > 12){
        hours = hours-12
    }
    else if (hours < 12){
        amPmSuffix = 'am'
    }
    const dateStr = (
        `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    )
    var minutes = `${date.getMinutes()}`
    if (minutes.length === 1){
        minutes = `0${minutes}`
    }
    const timeStr = `${hours}:${minutes} ${amPmSuffix}`
    return {date: dateStr, time: timeStr}
}

/*
 * Divides time range given as timestamp in hourly periods
 */
export const getVisitHours = (start, end) => {
    const hoursMilliseconds = 3600000
    var result = []
    var currentTime = start
    while (currentTime < end){
        result.push(currentTime)
        currentTime += hoursMilliseconds
    }
    return result
}

/*
 * Given a set of events, will filter them if required to get ongoing
 * or future events only
 */
export const parseEvents = (events, getAll) => {
    const today = new Date().getTime()
    const result = {}

    for (var eventId in events){
        if (
            events[eventId].start > today ||
            (events[eventId].start < today && events[eventId].end >= today)
            || getAll
        ){
            result[eventId] = {
                name: events[eventId].name,
                client_id: events[eventId].client_id,
                client_mail: events[eventId].client_mail,
                start: events[eventId].start,
                end: events[eventId].end,
                reservedSpaces: events[eventId].reservedSpaces,
                room: events[eventId].room,
                availableHours: []
            }
            for (var hourTimestamp in events[eventId].availableHours){
                result[eventId].availableHours.push({
                    time: Number(hourTimestamp),
                    ocupation: events[eventId].availableHours[hourTimestamp]
                })
            }
            // Sort by timestamp
            result[eventId].availableHours.sort(function (a, b) {
                if (a.time > b.time) {return 1;}
                if (a.time < b.time) {return -1;}
                return 0;
            })
        }
    }
    return result
}

/*
 * Will filter events given a filter object
 */
export const filterEvents = (events, filter) => {
    const result = {}
    const filterFlags = {
        client_id: filter.client_id.length > 0,
        name: filter.name.length > 0,
        room_id: filter.room_id !== 'all',
        eventDate: filter.eventDate !== null
    }
    for (var eventId in events){
        // Check client_id
        if (
            filterFlags.client_id &&
            events[eventId].client_id !== filter.client_id
        ){
            continue
        }
        // Check name
        if (
            filterFlags.name &&
            !events[eventId].name.toLowerCase().includes(filter.name.toLowerCase())
        ){
            continue
        }
        // Check roomId
        if (filterFlags.room_id && events[eventId].room.id !== filter.room_id){
            continue
        }
        // Check eventDate
        if (filterFlags.eventDate){
            const eventDate = parseTimestamp(events[eventId].start).date
            const dateToCompare = `${filter.eventDate.getDate()}/` +
                `${filter.eventDate.getMonth() + 1}/` +
                `${filter.eventDate.getFullYear()}`
            if (eventDate !== dateToCompare){
                continue
            }
        }
        result[eventId] = events[eventId]
    }
    return result
}

/*
 * Get event available space for selected timestamp
 */
export const getAvailableSpace = (event, selectedTimestamp) => {
    const filtered = event.availableHours.filter(
        el => {return el.time === selectedTimestamp}
    )
    const currentGuests = filtered[0].ocupation
    const roomSpace = event.room.capacity
    const reservedSpaces = event.reservedSpaces
    const result = roomSpace - currentGuests - reservedSpaces
    return result >= 0 ? result : 0
}

/*
 * Gets event guests occupation for selected timestamp
 */
export const getCurrentOccupation = (event, selectedTimestamp) => {
    if (!event){
        return 0
    }
    const filtered = event.availableHours.filter(
        el => {return el.time === Number(selectedTimestamp)}
    )
    return filtered[0].ocupation
}

export const reservationGuestsCount = reservation => {
    const guestsFound = reservation.guests.filter(
        el => {return el.name.length > 0}
    )
    return guestsFound.length + 1
}

/*
 * Filter reservations by selectedTime
 */
export const getReservationsForTime = (reservations, timeSelected) => {
    const result = {}
    for (var reservationId in reservations){
        if (reservations[reservationId].selectedTime === timeSelected){
            result[reservationId] = reservations[reservationId]
        }
    }
    return result
}

/*
 * Export reservations to PDF
 */
export const downloadReservations = (reservations, eventId) => {
    const doc = new jsPDF()
    const tableColumn = [
        "Id", "Nombre", "Telefono", "Correo", "Invitados", "Hora", "Productos"
    ]
    const tableRows = []
    for (var reservationId in reservations){
        const reservation = reservations[reservationId]
        const guests = reservation.guests.map(el => el.name).filter(
            el => el.length > 0
        )
        const products = reservation.products ? reservation.products.map(el => el.name) : []
        var total = 0
        for (var product in reservation.products){
            total += reservation.products[product].value
        }
        products.push(`Total: ${total}`)

        var email = reservation.personalData.mail
        if (email.length > 20){
            email = `${email.substring(0, email.indexOf('@'))}\n${email.substring(email.indexOf('@'))}`
        }
        const reservationRow = [
            reservationId,
            reservation.personalData.name,
            reservation.personalData.phone,
            email,
            guests.join('\n'),
            parseTimestamp(reservation.selectedTime).time,
            products.join('\n')
        ]
        tableRows.push(reservationRow)
    }
    // Set title and margin top, margin left
    if (reservations[reservationId]){
        const reservationDate = parseTimestamp(
        reservations[reservationId].selectedTime).date
        doc.text(
            `Evento ${eventId} llevado a cabo el día: ${reservationDate}`, 14, 15
        )
    } else {
        doc.text(`Evento ${eventId}`, 14, 15)
    }

    // StartY is margin-top
    doc.autoTable(tableColumn, tableRows, {startY:20})

    doc.save(`Reservaciones_${eventId}.pdf`)
}

export const filterParkings = (parkingEntries, startTime, endTime) => {
    var filterParkings = []
    for (var foundEndTime in parkingEntries){
        if (parseInt(foundEndTime) < startTime){
            continue
        }
        for (var eventId in parkingEntries[foundEndTime]){
            for (var resId in parkingEntries[foundEndTime][eventId]){
                const foundStartTime = parkingEntries[foundEndTime][eventId][resId]['start']
                if (foundStartTime > endTime){
                    continue
                }
                const recordFound = {
                    'eventId': eventId,
                    'resId': resId,
                    'expected_start': foundStartTime,
                    'start': null,
                    'end': parseInt(foundEndTime),
                    'plate': parkingEntries[foundEndTime][eventId][resId]['plate']
                }
                filterParkings.push(recordFound)
            }
        }
    }
    return filterParkings
}

export const sumReservedAndCurrentParkings = (
    filteredParkings, currentOccupation, endTime
) => {
    if (currentOccupation === null){
        return
    }
    for (var currentParkingEntry in currentOccupation){
        if (endTime < currentOccupation[currentParkingEntry]){
            continue
        }
        var found = false
        for (var expectedRes in filteredParkings){
            if (filteredParkings[expectedRes]['plate'] === currentParkingEntry){
                filteredParkings[expectedRes]['start'] = currentOccupation[currentParkingEntry]
                found = true
                break
            }
        }
        if (!found){
            filteredParkings.push({
                'eventId': null,
                'resId': null,
                'expected_start': null,
                'start': currentOccupation[currentParkingEntry],
                'end': null,
                'plate': currentParkingEntry
            })
        }
    }
}

/*
 * Send Reservation email
 */
export const sendReservationEmail = (reservation_id, reservation, event_name, parkingRes) =>{
    const reservationTimeData = parseTimestamp(reservation.selectedTime)
    const guestsCount = reservation.guests.filter(el => el.name.length > 0).length
    const products = reservation.products ? reservation.products.map(el => el.name) : ['No']
    var products_total = 0
    for (var prod in reservation.products){
        products_total += reservation.products[prod].value
    }
    emailjs.send("service_fouf639","template_reservation",{
        to_name: reservation.personalData.name,
        reservation_date: reservationTimeData.date,
        reservation_time: reservationTimeData.time,
        event_name: event_name,
        reservation_code: reservation_id,
        reservation_guests: guestsCount,
        reservation_products: products.join(','),
        products_total: products_total,
        parking_msg: parkingRes,
        branch_name: BRANCH_NAME,
        branch_url: BRANCH_URL,
        reservation_email: reservation.personalData.mail
    });
}

export const sendProductsEmail = (reservation_id, reservation, event_name) =>{
    const reservationTimeData = parseTimestamp(reservation.selectedTime)
    const products = reservation.products.map(el => el.name)
    var products_total = 0
    for (var prod in reservation.products){
        products_total += reservation.products[prod].value
    }
    emailjs.send("service_fouf639", "template_xjlbiaa",{
        branch: BRANCH_NAME,
        event_name: event_name,
        reservation_time: `${reservationTimeData.date} ${reservationTimeData.time}`,
        reservation_id: reservation_id,
        reservation_name: reservation.personalData.name,
        phone: reservation.personalData.phone,
        products: products,
        total: products_total
    });
}


export const sendProductsUpdateEmail = (reservation_id, reservation, event_name) =>{
    const reservationTimeData = parseTimestamp(reservation.selectedTime)
    const products = reservation.products.map(el => el.name)
    var products_total = 0
    for (var prod in reservation.products){
        products_total += reservation.products[prod].value
    }
    emailjs.send("service_fouf639", "template_zh83a18",{
        branch: BRANCH_NAME,
        event_name: event_name,
        reservation_time: `${reservationTimeData.date} ${reservationTimeData.time}`,
        reservation_id: reservation_id,
        reservation_name: reservation.personalData.name,
        phone: reservation.personalData.phone,
        products: products,
        total: products_total
    });
}


/*
 * Send Event creation email
 */
export const sendEventEmail = (eventId, event) =>{
    const eventTimeData = parseTimestamp(event.start)
    emailjs.send("service_fouf639","template_eventCreate",{
        event_name: event.name,
        event_date: eventTimeData.date,
        event_start: eventTimeData.time,
        event_end: parseTimestamp(event.end).time,
        event_room: event.room.name,
        event_reservedSpaces: event.reservedSpaces,
        room_space: event.room.capacity,
        event_code: eventId,
        branch_name: BRANCH_NAME,
        branch_url: BRANCH_URL,
        event_email: event.client_mail
    });
}

export const updateDict = (dict1, dict2) => {
    for (var key in dict2){
        if (dict1[key] == null){
            dict1[key] = dict2[key]
        }
    }
    return dict1
}

